package com.appcreator.blueprint.components

import com.appcreator.blueprint.core.Component
import com.appcreator.blueprint.core.ComponentClass
import com.appcreator.blueprint.core.DisplayIf
import com.appcreator.blueprint.core.InputProperty
import com.appcreator.blueprint.core.SkipSwiftGeneration
import com.appcreator.blueprint.core.properties.ComponentReference
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("ReferenceComponent")
@SkipSwiftGeneration
@ComponentClass(
    group = "Other",
    title = "Reference",
    availableFrom = "0.0.1"
)
data class ReferenceComponent(

    override val _nodeId: String?,
    override val _nodeLabel: String?,
    override val _nodeRelativeId: String?,

    @InputProperty(
        title = "Component",
        availableFrom = "0.0.1"
    )
    val content: ComponentReference?,

    @InputProperty(
        title = "component-references",
        availableFrom = "0.0.1",
    )
    @DisplayIf("it == DisplaySource.NodeTree")
    val children: List<Component>?,

): Component

